<template>
  <div class="worlds">
    <div class="container">
      <br/>
      <h1 class="is-size-4">World Double Bit Axe Throwing Championship 2022</h1>
      <br/>
      <div class="box worlds-box">
        <div class="columns is-mobile">
          <div class="column is-6">
            <span class="is-size-4" style="color: white;">Scorecard</span>
          </div>
          <div class="column is-6">
            <span class="is-size-4" style="color: white;">Date Time</span>
          </div>
        </div>
        <div v-for="scorecard in scorecards" :key="scorecard._id">
          <div class="columns is-mobile">
            <div class="column is-1">
              <span alt="show details" v-on:click="showPlayers(scorecard)">
                  <i v-if="!scorecard.displayPlayers" class="fas fa-chevron-up"></i> 
                  <i v-else class="fas fa-chevron-down"></i> 
              </span>
            </div>
            <div class="column is-6">
              <span class="is-size-4">
                <a style="color: yellow;" v-on:click="showScorecard(scorecard)"> {{ scorecard.title }}</a>
              </span>
            </div>
            <div class="column is-5">
              <span class="is-size-4" style="color: yellow;">{{ scorecard.dateTimeStamp | formatDateTime }}</span>
            </div>
          </div>
          <div class="box" style="margin-bottom: 20px;" v-if="scorecard.displayPlayers == true">
            <div class="columns is-mobile">
              <div class="column is-6">
                <span class="is-size-6"><u>Player</u></span>
              </div>
              <div class="column is-2">
                <span class="is-size-6"><u>Avg</u></span>
              </div>
              <div class="column is-2">
                <span class="is-size-6"><u>Ttl</u></span>
              </div>
              <div class="column is-2">
                <span class="is-size-6"><u>Thrw</u></span>
              </div>
            </div>
            <div v-for="player in scorecard.players" :key="player.id">
              <div class="columns is-mobile">
                <div class="column is-6">
                  {{ player.name }}
                </div>
                <div class="column is-2">
                  {{ player.averageThrow }}
                </div>
                <div class="column is-2">
                  {{ player.totalThrows }}
                </div>
                <div class="column is-2">
                  {{ player.throwCount }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'worlds',
    components : {
    },
    computed: {
    },
    data () {
      return {
        debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
        publicPath: process.env.BASE_URL,
        scorecards: [],
        errorMessage: '',
        showError: false,
        pleaseWait: true
      }
    },
    methods:{
      showPlayers: function(scorecard) {
        scorecard.displayPlayers = !scorecard.displayPlayers;
      },
      showScorecard: function(scorecard) {
        //console.log("showScorecard");
        //console.log(scorecard);

        var url = (this.debugMode ? "http://localhost:8080/scorecard/" : "https://axes2api.azurewebsites.net/scorecard/")
        url += scorecard._id;

        var token = this.$parent.getApiToken();

        axios.get(url,{
            headers: {
                authorization: token
            }
        })
        .then((response) => {
          //console.log(response.data);
          this.$parent.showModal(response.data);
        }, (error) => {
          alert(error);
        });

      },
      getScorecards: function () {
        var url = (this.debugMode ? "http://localhost:8080/worlds" : "https://axes2api.azurewebsites.net/worlds")
        var token = this.$parent.getApiToken();
        axios.get(url,{})
          .then((response) => {
            if (response.data.error != null) {
              this.errorMessage = response.data.error;
              this.showError = true;
              this.pleaseWait = false;
            } else {
              this.scorecards = response.data; 
              this.pleaseWait = false;
            }
          }, (error) => {
            this.errorMessage = error;
            this.showError = true;
            this.pleaseWait = false;
          });
      },
    },
    mounted(){
      this.getScorecards();
    }
}
</script>

<style lang="scss">
.worlds {
  color: goldenrod;
  background-color: black;
}
.worlds-box {
  color: goldenrod;
  background: #505050;
  min-height: 500px;
}
</style>